export default "__VITE_ASSET__9edb49a4__"